/// <reference path="../../../../../rest.d.ts"/>
/// <reference path="../../../../../typings/index.d.ts"/>
import * as angular from 'angular';

module App {
    class PermissionDeniedCtrl implements ng.IController {
        $onInit(): void {}
    }

    angular.module('app').component('pkpPermissionDenied', {
        controller: PermissionDeniedCtrl,
        template: require('app/_directives/pkp-permission-denied.directive.html')
    });
}
